import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteMethod, getMethod, postMethod, putMethod, setAuthorizationToken } from "../../utils/apiServices";

export const getAppliances = createAsyncThunk("appliances/applianceList", async (thunkApi) => {
  const response = await getMethod(`/api/appliance`);
  return response;
});

const initialState = {
  loading: false,
  success: false,
  error: false,
  appliances: null,
};

const applianceSlice = createSlice({
  name: "appliance",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAppliances.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppliances.fulfilled, (state, action) => {
        state.loading = false;
        state.appliances = action.payload.data;
      })
      .addCase(getAppliances.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export default applianceSlice.reducer;

export const addAppliance = (data, SuccessCallback, ErrorCallback) => async (dispatch) => {
  setAuthorizationToken(true);
  const response = await postMethod(`/api/admin/appliance`, data);
  if (response?.success) SuccessCallback(response);
  else ErrorCallback(response);
};

export const updateAppliance = (id, data, SuccessCallback, ErrorCallback) => async (dispatch) => {
  setAuthorizationToken(true);
  const response = await putMethod(`/api/admin/appliance/${id}`, data);
  if (response?.success) SuccessCallback(response);
  else ErrorCallback(response);
};

export const deleteAppliance = (id, SuccessCallback, ErrorCallback) => async (dispatch) => {
  setAuthorizationToken(true);
  const response = await deleteMethod(`/api/admin/appliance/${id}`);
  if (response?.success) SuccessCallback(response);
  else ErrorCallback(response);
};
